import { PaymentGateway } from 'components/PaymentGateway';
import { Page } from 'layouts/Page';

export const PaymentGatewayPage = () => {
	return (
		<Page title="Payment Gateway – EAS Control Center">
			<PaymentGateway />
		</Page>
	);
};
